import { render, staticRenderFns } from "./UiSidebar.vue?vue&type=template&id=c5e19ba4&lang=pug"
import script from "./UiSidebar.vue?vue&type=script&lang=js"
export * from "./UiSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports